<div *ngIf="!isLoading && duplicateSuspicions.length > 0" class="mb-2">
    <div class="alert alert-warning mb-0" *ngFor="let suspicion of duplicateSuspicions">
        <nb-icon icon="fa-exclamation-triangle"></nb-icon>
        {{ 'expense.duplicate-alert' | translate: {
            emitter: (suspicion.ExpenseId === expenseToEdit.Id ? suspicion.SuspectedDuplicate?.Emitter : suspicion.Expense?.Emitter) || '',
            amount: (suspicion.ExpenseId === expenseToEdit.Id ? suspicion.SuspectedDuplicate?.TotalTtc : suspicion.Expense?.TotalTtc) | number:'1.2-2',
            date: (suspicion.ExpenseId === expenseToEdit.Id ? suspicion.SuspectedDuplicate?.DateOnExpense : suspicion.Expense?.DateOnExpense) | date:'dd/MM/yyyy'
        } }}
        <button
            class="btn btn-sm btn-outline-warning ms-2"
            (click)="openDuplicateImage(suspicion)"
            *ngIf="(suspicion.ExpenseId === expenseToEdit.Id ? suspicion.SuspectedDuplicate?.ImageUrl : suspicion.Expense?.ImageUrl)"
        >
            <nb-icon icon="fa-image"></nb-icon>
            {{ 'expense.duplicate-view-receipt' | translate }}
        </button>
    </div>
</div>

<div
    class="row edit-page"
    *ngIf="!isLoading"
    [ngClass]="{ hide: editFormHidden }"
>
    <div
        class="col-sm-5 zoomable-image"
        *ngIf="expenseToEdit && expenseToEdit.ExpenseType.Code !== 'MGE'"
    >
        <ngx-image-viewer
            *ngIf="expenseToEdit?.ImageUrls?.length"
            [config]="imageConfig"
            [src]="expenseToEdit?.ImageUrls"
        >
        </ngx-image-viewer>
        <!--For retro-compatibility -->
        <ngx-image-viewer
            *ngIf="!expenseToEdit?.ImageUrls?.length && expenseToEdit?.ImageUrl"
            [config]="imageConfig"
            [src]="[expenseToEdit.ImageUrl]"
        >
        </ngx-image-viewer>
        <!-- <img [src]="expenseToEdit.ThumbUrl" class="expense-img" *ngIf="expenseToEdit.ThumbUrl"> -->
    </div>
    <div
        [ngClass]="{
            'col-sm-7': expenseToEdit.ExpenseType.Code !== 'MGE',
            'col-sm': expenseToEdit.ExpenseType.Code === 'MGE',
        }"
    >
        <on-edit-form
            [isNew]="isNew"
            (editionFinished)="editionFinishedListener($event)"
            [expense]="expenseToEdit"
            (isLoadingChange)="setEditFormHidden($event)"
            [report]="report"
        ></on-edit-form>
    </div>
</div>

<div class="row" *ngIf="isLoading || editFormHidden">
    <div class="col-12 text-center">
        <on-loading></on-loading>
    </div>
</div>

<ng-template #duplicateModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title">
            {{ 'expense.duplicate-receipt-title' | translate }}
            <small class="text-muted" *ngIf="duplicateEmitter">- {{ duplicateEmitter }}</small>
        </h5>
        <button type="button" class="btn-close" (click)="modal.dismiss()" aria-label="Close"></button>
    </div>
    <div class="modal-body text-center">
        <ngx-image-viewer
            *ngIf="duplicateImageUrl"
            [src]="[duplicateImageUrl]"
            [config]="imageConfig"
        ></ngx-image-viewer>
    </div>
</ng-template>
